import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import aiIcon from "../Assests/AI Assist.svg";
import reload from "../Assests/reload.svg";
import tick from "../Assests/Tick.svg";
import close from "../Assests/X.svg";
import BeatLoader from "react-spinners/BeatLoader";

const MultiStageButton = ({
  initialStatus = 'Generate',
  handleClick,
  handleReject,
  handleReload
}) => {
  const [status, setStatus] = useState(initialStatus);

  useEffect(() => {
    setStatus(initialStatus);
  }, [initialStatus]);

  const getButtonText = () => {
    switch (status) {
      case 'Generate':
        return 'Generate';
      case 'Creating':
        return '';
      case 'Accept':
        return 'Accept';
      default:
        return 'Generate';
    }
  };

  return (
    <div className='aiButton-container'>
      {
        status == 'Accept' && (
          <div className='aiCloseReload-button'>
            <button className='aiCloseReload-button1' onClick={handleReject}>
              <img className='aibuttonIcon' src={close} alt='closeicon' style={{ width: '2.4vh', height: '2.4vh' }} />
            </button>
            <button className='aiCloseReload-button2' onClick={handleReload}>
              <img src={reload} alt='reloadicon' style={{ width: '1.8vh', height: '1.8vh' }} />
            </button>
          </div>
        )
      }
      <button
        className='aigenerate-button'
        onClick={handleClick}
        disabled={status == 'Creating'}
      >
        <span>{getButtonText()}</span>
        {status === 'Generate' && (
          <img src={aiIcon} alt="AI Assist Icon" style={{ width: '2.4vh', height: '2.4vh' }} />
        )}
        {status === 'Accept' && (
          <img src={tick} alt="Tick Icon" style={{ width: '2.4vh', height: '2.4vh' }} />
        )}
        {status == 'Creating' &&
          <BeatLoader
            color="#000025"
            loading={true}
            size={'0.8vh'}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        }
      </button>
    </div>

  );
};

MultiStageButton.propTypes = {
  initialStatus: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  handleReject: PropTypes.func,
  handleReload: PropTypes.func
};

export default MultiStageButton;
